import NiceModal from "@ebay/nice-modal-react";
import { requester } from "App";
import P from "components/P";
import Container from "layouts/container/Container";

import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import ModalBase from "modals/base/ModalBase";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { format, parseISO } from "date-fns";
import { createForceSendoutData } from "shared/utils/Utils";


const PartnersRecentPaymentHistoryModal = NiceModal.create(props => {
    const { t } = useTranslation();
    const [withHeader, withFooter] = [false, false];
    const [width, height] = ["60%", "60%"];
    const withCloseButton = false;
    const modal = useRef();
    const clickOutsideToClose = true;
    // const title = t("");
    const title = "최근 결제내역(10건)";
    const buttonText = t("close");
    const headerStyle = {
        fontFamily: "Pretendard",
        fontSize: "2rem",
        fontWeight: "bold",
    }


    const [paymentHistory, setPaymentHistory] = useState([]);

    const handleForceSendout = (item) => {
        const sendoutData = createForceSendoutData(item);

        console.log("sendoutData : ", sendoutData)

        // WebSocket으로 전송
        requester.testOrder(sendoutData, (result) => {
            console.log('Force sendout request sent:', result);
        });
    };
    const handleClose = () => {
        // useRef로 참조한 modal 객체의 close 메서드를 호출합니다.
        modal.current.close();

        // 추가적으로 props.onClose도 호출할 수 있습니다.
        if (props.onClose) {
            props.onClose();
        }
    };

    useEffect(() => {
        const data = { storeCode: props.storeCode }
        requester.findPaymentHistoryByStoreCode((data), (result) => {
            setPaymentHistory(result.data);
            console.log(result.data)
        });

    }, [])

    return (
        <ModalBase
            ref={modal}
            width={width}
            height={height}
            withHeader={withHeader}
            withFooter={withFooter}
            withCloseButton={withCloseButton}
            clickOutsideToClose={clickOutsideToClose}
            title={title}
            buttonText={buttonText}
            overflow={"visible"}
            borderRadius={"25px"}
            headerStyle={headerStyle}
            onClose={props.onClose}
            backgroundColor={"white"}
        ><Container borderRadius={'25px'}>
                <VerticalFlex alignItems={'flex-start'} justifyContent={'flex-start'}>
                    <FlexChild padding={"3rem 3rem"} height={'fit-content'}>
                        <HorizontalFlex>
                            <FlexChild he>
                                <P size={"2.5rem"} weight={700}>최근 주문내역</P><P size={"2rem"} color={"#8B8B8B"}> (5건)</P>
                            </FlexChild>
                            <FlexChild justifyContent={'flex-end'} >
                                <P cursor size={"2.5rem"} onClick={handleClose}>X</P>
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    <FlexChild height={'fit-content'} >
                        <HorizontalFlex padding={"0px 50px 0px 50px"} alignItems={'flex-start'} height={'fit-content'} >
                            <FlexChild padding={"0px 0px 20px 0px"} height={'fit-content'} justifyContent={'center'} borderBottom={'1px solid #D9D9D9'}>
                                <P weight={700} color={"#626D7D"} size={"1.5rem"}>주문시각</P>
                            </FlexChild>
                            <FlexChild padding={"0px 0px 20px 0px"} height={'fit-content'} justifyContent={'center'} borderBottom={'1px solid #D9D9D9'}>
                                <P weight={700} color={"#626D7D"} size={"1.5rem"}>주문서 ID</P>
                            </FlexChild>
                            <FlexChild padding={"0px 0px 20px 0px"} height={'fit-content'} justifyContent={'center'} borderBottom={'1px solid #D9D9D9'}>
                                <P weight={700} color={"#626D7D"} size={"1.5rem"}>가격</P>
                            </FlexChild>
                            <FlexChild padding={"0px 0px 20px 0px"} justifyContent={'center'} borderBottom={'1px solid #D9D9D9'}>
                                <P weight={700} color={"#626D7D"} size={"1.5rem"}>DeviceCode</P>
                            </FlexChild>
                            <FlexChild padding={"0px 0px 20px 0px"} justifyContent={"flex-end"} borderBottom={'1px solid #D9D9D9'}>
                                <P weight={700} color={"#626D7D"} size={"1.5rem"}>기능고장</P>
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    {paymentHistory?.map((item, index) => (
                        <FlexChild key={index} height={'fit-content'} borderBottom={"1px solid grey"} padding={"10px 0px"} >
                            <HorizontalFlex padding={"20px 50px 10px 50px"} alignItems={'flex-start'} height={'fit-content'} backgroundColor={index % 2 === 1 ? "#F8F8F8" : "white"}>
                                <FlexChild justifyContent={'center'}>
                                    <P weight={700} size={"1.5rem"}> {item?.createDateTime
                                        ? format(parseISO(item.createDateTime.substring(0, 23)), "yyyy-MM-dd HH:mm:ss")
                                        : "-"
                                    }</P>
                                </FlexChild>
                                <FlexChild justifyContent={'center'}>
                                    <P weight={700} size={"1.5rem"}>{item?.trxId}</P>
                                </FlexChild>
                                <FlexChild justifyContent={'center'}>
                                    <P weight={700} size={"1.5rem"}>{item?.amount}</P>
                                </FlexChild>
                                <FlexChild justifyContent={'center'}>
                                    <P weight={700} size={"1.5rem"}>{item?.deviceCode}</P>
                                </FlexChild>
                                <FlexChild justifyContent={"flex-end"} >
                                    <div
                                        style={{ backgroundColor: "var(--main-color)", padding: "5px 20px", borderRadius: "5px", cursor: "pointer", width: "fit-content" }}
                                        onClick={() => handleForceSendout(item)}
                                    >
                                        <P size={"1.5rem"} color={'white'}>배출</P>
                                    </div>
                                </FlexChild>
                            </HorizontalFlex>
                        </FlexChild>
                    ))}
                </VerticalFlex>
            </Container>
        </ModalBase>
    );
});

export default PartnersRecentPaymentHistoryModal;
